export default function PointLine2() {
  return (
    <svg width="257" height="320" viewBox="0 0 257 320" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1072_3288)">
      <path d="M102.605 156.35L156.646 205.191" stroke="#E4E6EF" strokeWidth="1.88133" strokeLinecap="round"/>
      <path d="M99.2566 165.703C107.81 162.381 112.053 152.689 108.735 144.054C105.417 135.419 95.7936 131.111 87.2406 134.433C78.6875 137.754 74.4438 147.447 77.7619 156.082C81.0801 164.717 90.7036 169.024 99.2566 165.703Z" fill="#E4E6EF"/>
      <path d="M278.589 132.008C287.142 128.687 291.385 118.994 288.067 110.359C284.749 101.724 275.126 97.4168 266.573 100.738C258.02 104.06 253.776 113.752 257.094 122.387C260.412 131.022 270.036 135.33 278.589 132.008Z" fill="#E4E6EF"/>
      <path d="M179.344 217.055L201.865 81.2869" stroke="#E4E6EF" strokeWidth="1.88133" strokeLinecap="round"/>
      <path d="M173.232 201.442C181.785 198.121 191.409 202.428 194.727 211.063C198.045 219.698 193.801 229.391 185.248 232.712C176.695 236.034 167.072 231.726 163.754 223.091C160.436 214.456 164.679 204.764 173.232 201.442Z" fill="#E4E6EF"/>
      <path d="M206.77 54.6763L254.921 100.534" stroke="#E4E6EF" strokeWidth="1.88133" strokeLinecap="round"/>
      <path d="M221.945 61.4264C218.219 69.8443 208.398 73.6581 200.01 69.9448C191.622 66.2315 187.842 56.3972 191.569 47.9793C195.295 39.5614 205.116 35.7476 213.504 39.4609C221.893 43.1743 225.672 53.0086 221.945 61.4264Z" fill="#E4E6EF"/>
      </g>
      <defs>
      <clipPath id="clip0_1072_3288">
      <rect width="279.381" height="278.393" fill="white" transform="translate(0.109375 207) rotate(-66.1216)"/>
      </clipPath>
      </defs>
    </svg>
  );
}
